<template>
    <div class="">
        <div class="row">
            <div class="col">
                <advance-input-switch
                        v-bind="getInputProps({})"
                        color="gradient-blue"
                        v-model="inputValue"
                >
                    <template #hidden="{ checked }">
                        <input type="hidden" :name="name" :value="checked ? checkedValue : uncheckedValue">
                    </template>
                    <template #next="{ checked }">
                        <div class="position-relative d-inline-block float-right px-4 py-3 ml-2">
                            <span class="fit h5 text-gray font-weight-normal line-height-2 text-center m-0">
                                <template v-if="checked">
                                    {{ checkedLabel }}
                                </template>
                                <template v-else>
                                    {{ uncheckedLabel }}
                                </template>
                            </span>
                        </div>
                    </template>
                </advance-input-switch>
            </div>
        </div>
        <slot name="content" :enabled="enabled">
            <div class="row" v-if="enabled">
                <div class="col">
                    qui ci va il contento
                </div>
            </div>
        </slot>
    </div>
</template>

<script>

    import mixinCommon from '../mixinCommon.vue';
    import mixinInput from '../mixinInput.vue';
    import AdvanceInputSwitch from "../AdvanceInputSwitch.vue";

    export default {
        mixins: [ mixinCommon, mixinInput ],
        components: {
            'input-switch': AdvanceInputSwitch
        },
        props: {
            ...AdvanceInputSwitch.props
        },
        computed: {
            enabled: {
                get() {
                    return this.inputValue === 'string' ? !!+this.inputValue.trim() : !!+this.inputValue;
                },
                set( enabled ) {
                    this.inputValue = enabled ? '1' : '';
                }
            }
        },
        methods: {
            getInputProps( overrideProps = {} ) {
                return this.getComponentProps( AdvanceInputSwitch, overrideProps );
            }
        }
    }
</script>
